// Runtime UI feature flags, injected per environment by the /settings/*.js scripts in index.html.
// Always call these functions at the point of use - never cache the result in a module-level const.

// Enabled only when /settings/riskIqEnabled.js sets `window.riskIqEnabled = true` (boolean).
export const isRiskIqEnabled = (): boolean => window.riskIqEnabled === true;
